/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Features_Desk_PlanInputs */

const en_features_desk_plan = /** @type {(inputs: Features_Desk_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Workout plan`)
};

const pl_features_desk_plan = /** @type {(inputs: Features_Desk_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plan treningu`)
};

/**
* | output |
* | --- |
* | "Workout plan" |
*
* @param {Features_Desk_PlanInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const features_desk_plan = /** @type {((inputs?: Features_Desk_PlanInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Features_Desk_PlanInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_features_desk_plan(inputs)
	return en_features_desk_plan(inputs)
});